// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2IvA5","bigColWidth":"Table_bigColWidth__22AhX","biggerColWidth":"Table_biggerColWidth__2KwSP","row":"Table_row__2jvfS","col":"Table_col__2z-Fp"};